import isString from 'lodash/isString';

export const createHandleString = (input) => {
  if (!input || !isString(input)) {
    return '';
  }
  return (
    String(input)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-$/, '')
      .replace(/^-/, '') || ''
  );
};
